import React from 'react';


class BackgroundSelectItem extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e) {
        e.preventDefault();
        this.props.onBackgroundSelect(this.props.background);
    }

    render() {
        return (
            <a href="#" onClick={this.handleSelect} className={"background_select_item" + (this.props.active ? ' active' : '')}>
                <img src={this.props.background.icon_url} alt="" />
            </a>
        );
    }
  }

export default BackgroundSelectItem;



// WEBPACK FOOTER //
// ./src/BackgroundSelectItem.js